import React, { FC } from 'react';

const DropletIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="4"
      height="4"
      viewBox="0 0 4 4"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.96315 0.244726C1.55214 1.406 0.878906 1.86016 0.878906 2.67884C0.878906 2.97619 0.997028 3.26136 1.20729 3.47162C1.41754 3.68188 1.70271 3.8 2.00006 3.8C2.29741 3.8 2.58258 3.68188 2.79284 3.47162C3.0031 3.26136 3.12122 2.97619 3.12122 2.67884C3.12122 1.86016 2.44798 1.406 2.03698 0.244726C2.01587 0.185087 1.98426 0.185087 1.96315 0.244726Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default DropletIcon;
